<template>
  <div class="page">
    <div class="top">
      <!-- 左边展示商品视频或图片 -->
      <div class="view" @click="palyOrPause">
        <video
          id="video"
          ref="video"
          :src="videoSrc"
          :autoplay="autoplay"
          loop
          v-if="videoSrc"
        ></video>
        <img id="img" :src="imgSrc" alt="#" v-else />
      </div>
      <div class="detail">
        <h1>{{ huo.longName }}</h1>
        <div class="price">
          <span class="sharePrice">券后￥{{ huo.sharePrice }}</span>
          <span class="salePrice">原价￥{{ huo.salePrice }}</span>
        </div>
        <div class="pack">
          <table border="1px" width="760" height="100">
            <tr>
              <th>属性名称</th>
              <th>属性内容</th>
            </tr>
            <tr>
              <td width="260">颜色</td>
              <td>{{ huo.color != "none" ? huo.color : "" }}</td>
            </tr>
            <tr>
              <td>规格</td>
              <td>{{ huo.pack != "none" ? huo.pack : "" }}</td>
            </tr>
          </table>

          <!-- <h3>商品属性</h3>
          <span v-for="item in color" :key="item">{{ item }}</span>
          <span v-for="item in pack" :key="item">{{ item }}</span> -->
        </div>

        <div class="quan">
          <span>优惠券￥{{ huo.salePrice - huo.sharePrice }}</span>
        </div>
        <div class="btn">
          <span>领券购买</span>
          <span>分享推荐</span>
        </div>
      </div>
      <div class="ad"></div>
    </div>
    <div class="bottom">
      <h2 class="title">商品详情</h2>
      <div class="content">
        <div class="img1">
          <img
            v-for="item in picList.slice(0, picList.length - 2)"
            :key="item"
            :src="item"
            alt="#"
          />
        </div>
        <div class="img2">
          <img
            v-for="item in picList.slice(picList.length - 2, picList.length)"
            :key="item"
            :src="item"
            alt="#"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [
        {
          color: "浅蓝,红色",
          commission: "1",
          cover:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20190919/notebook1.jpg",
          huoId: "326633728623251456",
          likes: "569",
          longName: "简约商务笔记本加厚",
          pack: "none",
          picList:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/笔记本商品详情1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/笔记本商品详情2.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/笔记本商品详情3.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/笔记本商品详情4.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/笔记本商品详情5.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/笔记本商品详情7.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/通用（放最后）.jpg",
          saleCount: "500",
          salePrice: "5",
          sellerId: "202",
          sharePrice: "0.01",
          shortName: "商务笔记本",
          showbill:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20190919/notebook2.jpg",
          skuPrice: "{'浅蓝':'0.01','红色':'0.01'}",
          slide:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191030/notebook2.jpg",
          slideVertical: "1",
          video: "none",
          videoVertical: "1"
        },
        {
          color: "黄色,浅青色,深灰色,卡其色",
          commission: "50",
          cover:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200114/sofa_cover.jpg",
          huoId: "369012215379922944",
          longName:
            "北欧沙发椅单人斯佳蒙沙发黄色美式客厅洽谈椅布艺现代休闲老虎椅",
          pack: "none",
          picList:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200114/sofa1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200114/sofa2.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200114/sofa3.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200114/sofa4.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200114/sofa5.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200114/通用1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200114/通用2.jpg",
          salePrice: "1099",
          sellerId: "202",
          sharePrice: "980",
          shortName: "沙发",
          showbill:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200114/sofa_slider.jpg",
          skuPrice:
            "{'黄色':'980','浅青色':'980','深灰色':'980','卡其色':'980'}",
          slide:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200114/sofa_slider.jpg",
          slideVertical: "1",
          video: "none",
          videoVertical: "1"
        },
        {
          color: "none",
          commission: "5",
          cover:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20190808/1.jpg",
          huoId: "311431668047024128",
          likes: "205",
          longName: "三湖农场优质黄桃盒装5斤 ",
          pack: "湖北省内,湖北省外",
          picList:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/黄桃商品详情1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/黄桃商品详情2.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/黄桃商品详情3.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/黄桃商品详情4.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/黄桃商品详情5.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/黄桃商品详情7.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/通用（放最后）.jpg",
          saleCount: "300",
          salePrice: "75",
          sellerId: "179",
          sharePrice: "70",
          shortName: "三湖农场优质黄桃盒装5斤 ",
          showbill:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20190812/黄桃海报.jpg",
          skuPrice:
            "{'湖北省内包邮':'75','湖北省外运费10元':'85','湖北省内':'75','湖北省外':'85'}",
          slide: "none",
          slideVertical: "1",
          video:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20190811/2.mp4",
          videoVertical: "1"
        },
        {
          color: "none",
          commission: "5",
          cover:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20190808/果.jpg",
          huoId: "311433249131859968",
          likes: "363",
          longName: "三湖农场优质黄桃盒装10斤",
          pack: "湖北省内,湖北省外",
          picList:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/黄桃商品详情1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/黄桃商品详情2.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/黄桃商品详情3.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/黄桃商品详情4.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/黄桃商品详情5.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/黄桃商品详情7.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191112/通用（放最后）.jpg",
          saleCount: "260",
          salePrice: "140",
          sellerId: "179",
          sharePrice: "135",
          shortName: "三湖农场优质黄桃盒装10斤",
          showbill:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20190812/黄桃海报.jpg",
          skuPrice: "{'湖北省内':'135','湖北省外':'145'}",
          slide: "none",
          slideVertical: "1",
          video:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20191030/3.mp4",
          videoVertical: "1"
        },
        {
          color: "粉色,绿色",
          commission: "10",
          cover:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/cover.jpg",
          huoId: "369733166384025600",
          likes: "336",
          longName:
            "2019春秋新款女童小白鞋儿童运动鞋休闲韩版潮百搭真皮小学生板鞋",
          pack: "none",
          picList:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/2.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/3.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/4.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/通用1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/通用2.jpg",
          salePrice: "218",
          sellerId: "202",
          sharePrice: "198",
          shortName: "儿童运动鞋休闲",
          showbill:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/slider.jpg",
          skuPrice: "{'粉色':'198','绿色':'198'}",
          slide:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/slider.jpg",
          slideVertical: "1",
          video: "none",
          videoVertical: "1"
        },
        {
          color: "白黑,白蓝",
          commission: "10",
          cover:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/shoes_cover.jpg",
          huoId: "369737930333229056",
          likes: "501",
          longName:
            "秋季小白鞋青少年回力男鞋白鞋初中学生韩版潮流百搭运动帆布板鞋",
          pack: "none",
          picList:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/shoes_1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/shoes_2.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/shoes_3.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/shoes_4.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/shoes_5.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/shoes_6.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/通用1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/通用2.jpg",
          salePrice: "158",
          sellerId: "202",
          sharePrice: "138",
          shortName: "青少年回力男鞋",
          showbill:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/shoes_slider.jpg",
          skuPrice: "{'白黑':'138','白蓝':'138'}",
          slide:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/shoes_slider.jpg",
          slideVertical: "1",
          video: "none",
          videoVertical: "1"
        },
        {
          color: "棕色",
          commission: "100",
          cover:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/sofa_cover.jpg",
          huoId: "369741930281570304",
          likes: "230",
          longName:
            "北欧单人沙发简约现代可拆洗羽绒靠背设计师客厅卧室家用懒人躺椅",
          pack: "none",
          picList:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/sofa_1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/sofa_2.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/sofa_3.png,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/sofa_4.png,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/sofa_5.png,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/通用1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/通用2.jpg",
          salePrice: "3990",
          sellerId: "202",
          sharePrice: "3690",
          shortName: "单人沙发",
          showbill:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/sofa_slider.jpg",
          skuPrice: "{'棕色':'3690'}",
          slide:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/sofa_slider.jpg",
          slideVertical: "1",
          video: "none",
          videoVertical: "1"
        },
        {
          color: "灰色,黑色,杏色,米白色",
          commission: "5",
          cover:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/a_cover.jpg",
          huoId: "369748219803996160",
          likes: "275",
          longName:
            "出色的毛线针织连衣裙秋装高腰加厚毛衣裙女宽松显瘦短裙娃娃裙",
          pack: "none",
          picList:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/a_1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/a_2.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/a_3.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/a_4.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/a_5.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/通用1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/通用2.jpg",
          salePrice: "115",
          sellerId: "202",
          sharePrice: "105",
          shortName: "针织连衣裙",
          showbill:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/a_slider.jpg",
          skuPrice: "{'灰色':'105','黑色':'105','杏色':'105','米白色':'105'}",
          slide:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/a_slider.jpg",
          slideVertical: "1",
          video: "none",
          videoVertical: "1"
        },
        {
          color: "红色",
          commission: "20",
          cover:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/b_cover.jpg",
          huoId: "369750723698626560",
          likes: "440",
          longName:
            "2019新款夏法式小红裙红色镂空水溶蕾丝连衣裙短裙矮个子女士裙子",
          pack: "none",
          picList:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/b_1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/b_2.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/b_3.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/通用1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/通用2.jpg",
          salePrice: "399",
          sellerId: "202",
          sharePrice: "369",
          shortName: "法式小红裙",
          showbill:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/b_slider.jpg",
          skuPrice: "{'红色':'369'}",
          slide:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/b_slider.jpg",
          slideVertical: "1",
          video: "none",
          videoVertical: "1"
        },
        {
          color: "黑色",
          commission: "25",
          cover:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/c_cover.png",
          huoId: "369753520213069824",
          likes: "369",
          longName:
            "黑色西装裙连衣裙秋季气质名媛长袖翻领法式小外套英伦风百褶裙子",
          pack: "none",
          picList:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/c_1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/c_2.png,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/c_3.png,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/通用1.jpg,https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/通用2.jpg",
          salePrice: "799",
          sellerId: "202",
          sharePrice: "569",
          shortName: "黑色西装裙",
          showbill:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/c_slider.png",
          skuPrice: "{'黑色':'569'}",
          slide:
            "https://maituitest-1257142920.cos.ap-shanghai.myqcloud.com/huo/20200116/c_slider.png",
          slideVertical: "1",
          video: "none",
          videoVertical: "1"
        }
      ],
      huo: {},
      videoSrc: null,
      imgSrc: null,
      picList: []
    };
  },
  methods: {
    init() {
      this.huo = this.data.filter(r => r.huoId == this.$route.query.id)[0];
      this.videoSrc = this.huo.video != "none" ? this.huo.video : null;
      this.imgSrc =
        this.huo.slide != "none" ? (this.huo.slide || "").split(";")[0] : null;
      this.picList = (this.huo.picList || "").split(",");
    },
    palyOrPause() {
      // 视频的播放与暂停
      if (this.$refs.video) {
        let video = this.$refs.video;
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="less" scoped>
.page {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding: 20px 0;
  .top {
    overflow: hidden;
    margin-bottom: 20px;
    .view {
      width: 300px;
      height: 534px;
      float: left;
      #video {
        width: 100%;
        height: 100%;
      }
      #img {
        width: 100%;
        height: 100%;
      }
    }
    .detail {
      width: 760px;
      height: 534px;
      float: left;
      padding: 5px 30px;
      .price {
        width: 100%;
        font-size: 20px;
        margin-top: 30px;
        .sharePrice {
          height: 30px;
          line-height: 30px;
          padding: 0 10px;
          border-radius: 4px;
          color: #ff5b38;
          display: inline-block;
          font-weight: 700;
          font-size: 28px;
        }
        .salePrice {
          height: 30px;
          line-height: 30px;
          padding: 0 20px;
          color: #ccc;
          display: inline-block;
          text-decoration: line-through;
        }
      }
      .pack {
        padding: 15px 0;
        margin-top: 20px;
        span {
          height: 24px;
          line-height: 24px;
          display: inline-block;
          padding: 0 15px;
          border: 1px solid #ccc;
          border-radius: 4px;
          margin-right: 10px;
        }
        table {
          border: 1px solid #ccc;
          tr {
            border-color: #eee;
          }
        }
      }
      .quan {
        padding: 15px 0;
        span {
          height: 30px;
          line-height: 30px;
          display: inline-block;
          padding: 0 10px;
          color: #ff5b38;
          font-size: 20px;
          border-radius: 4px;
        }
      }
      .btn {
        padding: 15px 0;
        span {
          height: 40px;
          line-height: 40px;
          display: inline-block;
          padding: 0 20px;
          font-size: 24px;
          margin-right: 20px;
        }
        span:first-child {
          color: #ff0036;
          border: 1px solid #ff0036;
          background-color: #ffeded;
        }
        span:last-child {
          color: #fff;
          border: 1px solid #ff0036;
          background-color: #ff0036;
        }
      }
    }
    .ad {
      width: 140px;
      height: 534px;
      float: left;
    }
  }
  .bottom {
    width: 100%;
    border-top: 1px solid #eee;
    .title {
      width: 100%;
      text-align: left;
      margin: 10px 0 10px 20px;
    }
    .content {
      overflow: hidden;
      .img1 {
        float: left;
        width: 650px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 620px;
          height: auto;
        }
      }
      .img2 {
        float: left;
        width: 550px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 400px;
          height: auto;
        }
      }
    }
  }
}
th,
td {
  padding: 10px;
}
</style>
